export const generateRandomIPAddress = () => '0.0.0.0';
